var React = require('react');

function IconCheckboxEmpty (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"0.5","y":"0.5","width":"15","height":"15","rx":"1.5","stroke":"#636F7E"}));
}

IconCheckboxEmpty.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = IconCheckboxEmpty;

IconCheckboxEmpty.default = IconCheckboxEmpty;
